import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { classNames } from "../styles/classNames";

interface DropdownChevronProps {
  open: boolean;
  className?: string;
}

export default function DropdownChevron({ open, className }: DropdownChevronProps) {
  return (
    <ChevronDownIcon
      className={classNames("app-button-chevron", open && "app-button-chevron-open", className)}
      aria-hidden="true"
    />
  );
}
